import React from 'react';
import useAppContext from 'flow/hooks/useAppContext';
import { twMerge } from 'tailwind-merge';

interface Props {
    className?: string;
    /** Overrides the default copy - see the companion banner in CallItem. */
    label?: string;
}

const CallOnOtherDevice = ({ className, label }: Props) => {
    const { i18next } = useAppContext();

    return (
        <div
            className={twMerge(
                'bg-yellow flex w-full items-center justify-center rounded font-bold text-gray-800',
                className,
            )}
        >
            {label ?? i18next.t('call.canvas.call_on_other_device')}
        </div>
    );
};

export default CallOnOtherDevice;
